import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import {
  addDemurrage,
  fetchCFSNameByCountry,
  fetchEmptyYardNameByCountry,
  getAttachmentsOnly,
  getDeliveryOrderDataForExtension,
  getDemurrageView,
} from "../../../dashboard/actions/instruction";

interface IDemurrageFormView {
  blId: any,
  senderEmail: string | null;
  country: string | null;
  intendedDate: string | null;
  remarks: string | null;
  userRemarks: string | null;
  status: string | null;
  list: any[];
  attList: any[];
  extensionAttList: any[];
  requestedPartnerName: string | null;
  dndInstructionId: number | string | null;
  requestedPartnerId: number | string | null;
  groupLevel:number;
  cfsName:string;
  emptyYardName:string;
  version?:number | null;
}

interface IDemurrageContainerDetails {
  //vesselType: any;
  containerNo: string | null;
  IntendedDate: string | null;
}

interface IDemurrageListView {
  list: any[];
  next: string | null;
  previous: string | null;
}

export interface IDemurrageDetails {
  data: IDemurrageListView;
  isDemurrageDetailsLoading: boolean;
  dataLoading: boolean;
  demurrageForm: IDemurrageFormView;
  cfsList: Array<any>;
  emptyYardList:Array<any>
  // containerDetails: IDemurrageContainerDetails;
}

const initialState: IDemurrageDetails = {
  data: {
    list: [],
    next: null,
    previous: null,
  },
  cfsList:[],
  emptyYardList:[],
  dataLoading: true,
  isDemurrageDetailsLoading: false,
  demurrageForm: {
    blId:null,
    senderEmail: "",
    intendedDate: "",
    status: "",
    remarks: "",
    userRemarks:'',
    country: "",
    list: [],
    attList: [],
    extensionAttList: [], // files for extension request
    requestedPartnerName: "",
    dndInstructionId: null,
   requestedPartnerId: null,
    groupLevel:0,
    cfsName:"",
    emptyYardName:""
  },
};

export const DemurrageSlice = createSlice({
  name: "demurrageView",
  initialState,
  reducers: {
    resetDemurrageViewSlice: (state, action: any) => {
      state.demurrageForm = initialState.demurrageForm;
    },
    updateDemurrageList: (state, action: PayloadAction<IDemurrageListView>) => {
      state.data = action.payload;
    },
    updateDemurrageListView: (state, action: PayloadAction<any>) => {
      // state.taxId = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(addDemurrage.pending, (state, action) => {
      state.dataLoading = true;
    });
    builder.addCase(addDemurrage.fulfilled, (state, action) => {
      state.dataLoading = false;
    });
    builder.addCase(getDemurrageView.pending, (state, action) => {
      state.dataLoading = true;
    });
    builder.addCase(getDemurrageView.fulfilled, (state, action) => {
      state.dataLoading = false;
      state.demurrageForm = {
        senderEmail: action?.payload?.data?.customerEmailId || "",
        remarks: action?.payload?.data?.remarks || "",
        userRemarks: action?.payload?.data?.userRemarks || '',
        country: action?.payload?.data?.country || "",
        status: action?.payload?.data?.status || "",
        intendedDate: new Date().toISOString(),
        list: action?.payload?.data?.list || [],
        requestedPartnerName: action?.payload?.data?.requestedPartnerNm || "",
        requestedPartnerId: action?.payload?.data?.requestedPartnerId ?? null,
        attList: action?.payload?.data?.attList || [],
        extensionAttList: action?.payload?.data?.attList || [],
        dndInstructionId: action?.payload?.data?.dndInstructionId || null,
        blId: action?.payload?.data?.blId,
        groupLevel:action?.payload?.data?.groupLevel??0,
        cfsName:"",
        emptyYardName:"",
        version:action?.payload?.data?.version,
      };

      //state.demurrageForm = {
      // number: action?.payload?.number || '',
      //senderEmail: action?.payload.data?.customerEmailId || '',
      //IntendedDate: action?.payload.data?.customerEmailId,
      // state.data= action.payload;
      //};
    });

    builder.addCase(fetchCFSNameByCountry.fulfilled,(state,action:any)=>{
      state.cfsList = action.payload
    })
    builder.addCase(fetchEmptyYardNameByCountry.fulfilled,(state,action:any)=>{
      state.emptyYardList = action.payload
    })
    builder.addCase(getDemurrageView.rejected, (state, action) => {});
    builder.addCase(getAttachmentsOnly.fulfilled,(state,action:any)=>{
      // setting back the 
      state.demurrageForm.attList = []
      state.demurrageForm.extensionAttList = []
      if(action?.payload?.id)state.demurrageForm.dndInstructionId = action.payload.id
      if(action?.payload?.status)state.demurrageForm.status = action.payload.status
      if(action?.payload?.level)state.demurrageForm.groupLevel = action.payload.level
      //if(action?.payload?.chk)state.demurrageForm.groupLevel =action.payload.chk
      if(!action.payload?.att)return
      state.demurrageForm.attList = action.payload.att
      state.demurrageForm.version=action.payload.version
      state.demurrageForm.extensionAttList = action.payload.att
      
    })
    builder.addCase(getDeliveryOrderDataForExtension.fulfilled,(state,action:any)=>{
      // setting back the 
      // state.demurrageForm.attList = []
      state.demurrageForm.extensionAttList = []

      // if(action?.payload?.id)state.demurrageForm.dndInstructionId = action.payload.id
      // if(action?.payload?.status)state.demurrageForm.status = action.payload.status
      // if(action?.payload?.level)state.demurrageForm.groupLevel = action.payload.level
      //if(action?.payload?.chk)state.demurrageForm.groupLevel =action.payload.chk
      if(!action.payload?.data?.extensionAttList)return
      // state.demurrageForm.attList = action.payload.att
      state.demurrageForm.extensionAttList = action.payload.data.extensionAttList

      
    })
  },
});
export const { updateDemurrageList, resetDemurrageViewSlice } =
  DemurrageSlice.actions;

export default DemurrageSlice.reducer;
